/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { CommunicationAttachmentDto } from '../communications';

export const EDocSigningStatus = createEnum('EVERSIGN_STATUS', {
  New: 'NEW',
  Sent: 'SENT',
  Failed: 'FAILED',
  Cancelled: 'CANCELLED',
  Signed: 'SIGNED',
  Expired: 'EXPIRED',
});

export type EDocSigningStatus = EnumSet<typeof EDocSigningStatus>;

export const EDocType = createEnum('SIGN_DOC_TYPES', {
  Contract: 'CONTRACT',
  JobSpec: 'JOB_SPEC',
  Plans: 'PLANS',
  AuthToCommence: 'AUTH_TO_COMMENCE',
  ColorSelection: 'COLOR_SELECTION',
  Other: 'OTHER',
  Quote: 'QUOTE',
  AuthToProceed: 'AUTH_TO_PROCEED',
});

export type EDocType = EnumSet<typeof EDocType>;

export const EDocSignerRole = createEnum('EDOC_SIGNER_ROLE', {
  Office: 'OFFICE',
  Owner1: 'OWNER1',
  Owner2: 'OWNER2',
  Owner3: 'OWNER3',
});

export type EDocSignerRole = EnumSet<typeof EDocSignerRole>;

export type EDocSignerDto = {
  name: string;
  email: string;
  signedDate?: Date;
  status: EDocSigningStatus;
  type: EDocSignerRole;
};

export type EDocDto = {
  id: ID;
  externalId: ID;
  addedDate: Date;
  quotationName: string;
  sender: string;
  status: EDocSigningStatus;
  docType: EDocType;
  signers: EDocSignerDto[];
  files: Hash<string>;
};

export type EDocDetailsDto = {
  id: ID;
  externalId: ID;
  addedDate: Date;
  quotationName: string;
  sender: string;
  status: EDocSigningStatus;
  docType: EDocType;
  signers: EDocSignerDto[];
  files: CommunicationAttachmentDto[];
};
